export class Shape1DClass {
}
//# sourceMappingURL=Shape1DClass.js.map